import React, { useCallback } from 'react';
import classes from './style.module.scss';
import Button from 'app/common/Button/index';
import useTranslation from 'app/hooks/useTranslation';
import useForm from "~/app/modules/form/useForm";
import { APIResponse, ServiceDetails, ServiceCompletePayload } from "~/types";
import { useStoreActions, useStoreState } from "~/store";
import { notify } from '~/app/helpers/notify';

export interface FooterProps {
    onClose: () => void
    serviceDetails: ServiceDetails
    onSave?: (id: ServiceDetails['id']) => void
}

export type FooterComponent = React.FC<FooterProps>;

const Footer: FooterComponent = ({ onClose, serviceDetails, onSave }) => {
    const { t } = useTranslation('service');
    const { t: tIssue } = useTranslation('issue');
    const { values: formValues, formEvents: { onSubmit } } = useForm<ServiceCompletePayload>({ formName: 'completeService' });
    const checksData = useStoreState(state => state.serviceCheck.checksData);
    const completeServiceAction = useStoreActions(actions => actions.service.completeService);
    const fetching = useStoreState(state => state.service.fetching);
    const userName = useStoreState(state => state.user.data.name);
    const serviceId = serviceDetails.id;
    const workOrderId = serviceDetails.workOrderId;

    const saveClickHandler = useCallback((): void => {
        onSubmit(({ formState: { invalid } }) => {
            if (invalid) {
                return;
            }
            const payload: ServiceCompletePayload = {
                ...formValues,
                ...(serviceId && { serviceId }),
                ...(workOrderId && { workOrderId }),
                checklist: checksData
            } as ServiceCompletePayload;
            
            completeServiceAction(payload).then(async (data: APIResponse) => {
                onClose();
                if (data.success && serviceId) {
                    onSave?.(serviceId);
                    notify(t(`success.completed`), 'success');
                } else {
                    notify(tIssue(`error.${data?.msg}`, {userName: data?.msg && data.msg === 'userAlreadyExistForSelectedDate' ? userName : ''}), 'error');
                }

            });
        })();
    }, [onSubmit, formValues, serviceId, workOrderId, completeServiceAction, t, tIssue, onClose, onSave, userName, checksData]);


    return (
        <div className={`${classes['footer']}`}>
            <Button
                className={classes['abort']}
                onClick={onClose}>{t('cancel')}</Button>
            <Button
                className={classes['submit']}
                loading={fetching}
                onClick={saveClickHandler}>{t('serviceClose.complete')}</Button>
        </div>
    );
};

export default Footer
